var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"lbDateInput {{vm.class}}\" ng-click=\"vm.openDatePicker($event)\">\n<label><i class=\"ico-calendar\"></i>\n<input type=\"text\" name=\"{{vm.name}}\" id=\"{{vm.name}}\" ng-model=\"vm.date\" ng-focus=\"vm.openDatePicker($event)\" ng-required=\"vm.required\" ng-disabled=\"vm.disabled\" readonly=\"readonly\"/></label>\n</div>\n";
var id1="components/lbDateInput/lbDateInput.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbDateInput/lbDateInput.html
// module id = 1729
// module chunks = 5